export const USER_INFO = 'user/userInfo';
export const IS_Register = 'user/isRegister';